import React, { useState } from 'react';

function StepTwelve({ formData, onNext }) {
    const [hasStudentLoan, setHasStudentLoan] = useState(formData.hasStudentLoan || '');
    const [loanDetails, setLoanDetails] = useState(formData.loanDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!hasStudentLoan) {
            setError('Please select Yes or No.');
            return;
        }

        if (hasStudentLoan === 'yes' && !loanDetails.trim()) {
            setError('Please provide details of your student loan deductions.');
            return;
        }

        setError('');
        onNext({ hasStudentLoan, loanDetails });
    };

    const isFormValid =
        hasStudentLoan === 'no' || (hasStudentLoan === 'yes' && loanDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">Student Loan</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Do you have a student loan? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="studentLoan"
                            id="loanYes"
                            value="yes"
                            checked={hasStudentLoan === 'yes'}
                            onChange={() => setHasStudentLoan('yes')}
                        />
                        <label className="form-check-label" htmlFor="loanYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="studentLoan"
                            id="loanNo"
                            value="no"
                            checked={hasStudentLoan === 'no'}
                            onChange={() => setHasStudentLoan('no')}
                        />
                        <label className="form-check-label" htmlFor="loanNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {hasStudentLoan === 'yes' && (
                <div className="mb-3">
                    <label className="form-label">
                        Please provide details of the student loan deductions <span className="text-danger">*</span>
                    </label>
                    <textarea
                        className="form-control"
                        rows="3"
                        value={loanDetails}
                        onChange={e => setLoanDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepTwelve;
